import { BLACK, PRIMARY_PURPLE } from '../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../theme/fontConstants';

const styles = {
  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 450,
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    p: 3,
  },

  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 3,
  },

  title: {
    fontFamily: PRIMARY_FONT[700],
    fontSize: '18px',
    color: BLACK[100],
  },

  closeButton: {
    color: PRIMARY_PURPLE[70],
    p: 0.5,
  },

  label: {
    fontFamily: PRIMARY_FONT[500],
    fontSize: '14px',
    color: PRIMARY_PURPLE[70],
    display: 'block',
  },

  input: {
    '& .MuiOutlinedInput-root': {
      height: '40px',
      width: '280px',
      borderRadius: 1,
      '& fieldset': {
        borderColor: PRIMARY_PURPLE[70],
      },
      '&:hover fieldset': {
        borderColor: PRIMARY_PURPLE[70],
      },
      '&.Mui-focused fieldset': {
        borderColor: PRIMARY_PURPLE[70],
      },
    },
  },

  saveButton: {
    borderColor: PRIMARY_PURPLE[70],
    color: PRIMARY_PURPLE[70],
    fontFamily: PRIMARY_FONT[500],
    height: '40px',
    minWidth: '100px',
    '&:hover': {
      borderColor: PRIMARY_PURPLE[80],
      backgroundColor: PRIMARY_PURPLE[10],
    },
  },

  ssnDisplayContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },

  ssnDisplayText: {
    fontFamily: PRIMARY_FONT[400],
    fontSize: '16px',
  },

  editButton: {
    color: PRIMARY_PURPLE[70],
    textDecoration: 'underline',
    fontFamily: PRIMARY_FONT[400],
    fontSize: '14px',
    p: 0,
    minWidth: 'auto',
  },

  visibilityButton: {
    color: PRIMARY_PURPLE[70],
    p: 0.5,
  },

  fieldContainer: {
    mb: 4,
  },

  fieldContainerSmall: {
    mb: 1,
  },

  fieldContainerMedium: {
    mb: 2,
  },

  verifySsnContainer: {
    display: 'flex',
    gap: 1,
    justifyContent: 'space-between',
  },

  datePickerContainer: {
    display: 'flex',
    gap: 1,
    justifyContent: 'space-between',
  },
};

export default styles;
